import flags from "Shared/icons/flags/1x1png";

export function getFlag(country) {
	const lowerCaseCountry = country.toLowerCase();
	return flags[lowerCaseCountry];
}
